<template>
    <div>
        <sweet-modal blocking :title="$t('modal_settings_addCategory')" ref="createCategoryModal"  class="modal" v-on:close="closeModal">
            <el-form :model="form" ref="form" status-icon :rules="rules" label-width="0" class="demo-ruleForm">
                <el-form-item v-if="value" prop="name">
                    <el-input :value="value" @input="(val) => $emit('input', val)" :placeholder="$t('modal_settings_CategoryName')"></el-input>
                </el-form-item>
                <el-form-item v-else prop="name">
                    <el-input :placeholder="$t('modal_settings_CategoryName')" v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="addItem('form')" class="modal__btn" type="primary" plain size="small">{{$t('modal_settings_addCategory')}}</el-button>
                </el-form-item>
            </el-form>
        </sweet-modal>
    </div>
</template>
<script>
import axios from 'axios'
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
export default{
  name: 'create-category',
  props: ['value'],
  components:{
    SweetModal,

  },
  data(){
    return {
        form:{
          name: ''
        },
        rules: {
          name: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ]
        },
    }
  },
  methods:{
    openModal(){
      this.$refs.createCategoryModal.open()
    },
    addItem(form){
      this.$refs[form].validate((valid) => {
        if (valid) {
          let data = {
            name: this.form.name || this.value
          }
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/companyCategories/create?companyId=${this.$route.query.companyId}`, data)
            .then(response => {
              this.notification(this.$t('modal_settings_success'), this.$t('modal_settings_addCategory'), "success");
              // this.loadList(this.state)
              if(this.$route.name === 'settings'){
                this.$emit('loadList', 'companyCategories')
              }else if(this.$route.name === 'settings' && this.value){
                let newCategory = {
                  name: this.value || this.form.name,
                  id: response.data.companyCategoryId
                }
                console.log('newCategory', newCategory)
                this.$emit('setNewCategory', newCategory)
              }
              this.$refs.createCategoryModal.close()
            }).catch(error => {
              console.log('An error occurred:', error);
            });
        }else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    closeModal(){
      // this.form.no = ''
      this.form.name = ''
      this.$refs['form'].resetFields();
    },
  }
}
</script>
